import { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next'


import Backdrop from '../Backdrop/Backdrop';
import ModalConfirm from '../Modal/ModalConfirm';
import SelectPeriodUsage from './SelectPeriodUsage';
import GetPaymentMethods from '../UsageBasedPayment/GetPaymentMethods';
import PaymentMethods from '../UsageBasedPayment/PaymentMethods';
import CreateUsageBasedSubscription from './CreateUsageBasedSubscription';
import GetUsageBasedSubscription from './GetUsageBasedSubscription';

import { useStore } from '../../hook-store/store';

import classes from './UsageBasedBilling.module.css';

function UsageBasedBilling(props) {

  const [t] = useTranslation('translation')

  const [store, dispatch] = useStore();
  // const { freeSizeGB } = store.bucketObjectStore;
  const { 
    usageBasedPrice,
    usageBasedSubscription,
  } = store.stripeData;
  const { gLoading } = store.uiStore;

  const [displayContent, setDisplayContent] = useState('');
  
  useEffect(() => {
    window.scrollTo(0,0);
  },[]);


  let usageBaseResultBody;

  usageBaseResultBody = (
    <div>
      {/* <Backdrop
        zIndex={20}
        onCancel={() => {
          dispatch('SET_SHOWUSAGEBASEDMODAL', false);
        }}
      />
      <ModalConfirm
        onClose={() => {
          dispatch('SET_SHOWUSAGEBASEDMODAL', false);
        }}
        hideButtons={true}
      > */}
        <div>
          {!usageBasedPrice && (
            <GetUsageBasedSubscription />
          )}
          
          {usageBasedPrice && !usageBasedSubscription && (
            <div>
              <CreateUsageBasedSubscription />
            </div>
          )}

          {usageBasedSubscription && (
            <div>
              <div className={classes.usageBasedBillingRow}>
                <div className={classes.usageBasedBillingButtons}>
                  <button className='btnBase'
                    onClick={() => setDisplayContent('payment')}
                  >
                    {t('usageBased04', 'Manage payment methods')}
                  </button>
                  <button className='btnBase'
                    onClick={() => setDisplayContent('usage') }
                  >
                    {t('usageBased05', 'Usage records')}
                  </button>
                </div>
              </div>
              {displayContent === 'payment' && (
                <div>
                  <GetPaymentMethods />
                  <PaymentMethods />
                </div>
              )}

              {displayContent === 'usage' && (
                <SelectPeriodUsage />
              )}
            </div>
          )}

          {/* {!usageBasedSubscription || usageBasedSubscription.status === 'canceled' && (
            <div>
              handle-resume-or-create-sub
            </div>
          )} */}
        </div>
 
      {/* </ModalConfirm> */}
    </div>
  );




  return (
    <Fragment>
      <div>{usageBaseResultBody}</div>
    </Fragment>
  );
}

export default UsageBasedBilling;
